<template>
  <div class="modal-level2-bottom">
    <div class="mr20" @click="showModal()" v-if="$get($store, 'state.permissions.28.allow')">
      PRAQUALIFIKASI
    </div>
    <!-- <div
      class="mr20"
      @click="updateLandingPage()"
      v-if="$get($store, 'state.permissions.29.allow')"
    >
      UPDATE LANDING PAGE
    </div> -->
    <div class="mr20" @click="setEdit()" v-if="$get($store, 'state.permissions.30.allow')">
      <!-- {{ $get($store, 'state.editStore.isEditInfo') ? 'CANCEL' : 'EDIT' }} -->
      {{
        editingStatus == 1 || editingStatus == true
          ? `CANCEL ( ${editingUser} )`
          : `EDIT`
      }}
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    editingStatus() {
      return this.$get(
        this.$store,
        'state.editingStore.information_level_1.is_open',
        0
      )
    },
    editingUser() {
      return this.$get(
        this.$store,
        'state.editingStore.information_level_1.open_by',
        ''
      )
    },
    editingId() {
      return this.$get(
        this.$store,
        'state.editingStore.information_level_1.id',
        ''
      )
    },
  },
  methods: {
    setPraqualifikasi() {
      this.$store.commit('myRequest/SET_EXTEND', {
        id: this.$get(this.$store, 'state.level1.profile.id'),
        nama_vendor: this.$get(this.$store, 'state.level1.profile.nama_vendor'),
        alias_profile: this.$get(
          this.$store,
          'state.level1.profile.badan_usaha.alias_profile'
        ),
      })
    },
    async showModal() {
      await this.setPraqualifikasi()
      await this.$store.commit('modalReqApp/SET_VALUE', {
        value: true,
        name: 'modalPraqualifikasiLevel2',
      })
      // await this.$router.push({ path: '/myrequest/new/5' })
    },
    updateLandingPage() {
      this.$store.commit('SET_NOTIF', 'Maaf, Fitur sedang dalam pengembangan.')
    },
    setEdit() {
      // this.$store.commit('editStore/SET_EDIT_INFO')
      if (this.editingStatus == 1 || this.editingStatus == true) {
        this.$store.dispatch('editingStore/deleteEditingStatus', {
          id: this.editingId,
          is_open: 0,
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          vendor_id: this.$store.state.level1.vendorId,
          name: 'information_level_1',
        })
      } else {
        this.$store.dispatch('editingStore/addEditingStatus', {
          is_open: 1,
          desc: 'information_level_1',
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          vendor_id: this.$store.state.level1.vendorId,
          name: 'information_level_1',
          onSuccess: () => { },
        })
      }
      // this.$store.commit('SET_NOTIF', 'Maaf, Fitur sedang dalam pengembangan.')
    },
  },
}
</script>
